import type { JSX } from 'react';
import { Box } from '@mui/material';
import { LOADING_TEXT } from '@zero-dash/types';
import LoadingAnimation from '@/components/Animations/LoadingAnimation';
import CustomTypography from '@/components/Common/Typography';
import { ChartLaneMessage } from './ChartLane.styles';

const LOADING_ANIMATION_HEIGHT_PX = 70;

export default function ChartLaneLoading(): JSX.Element {
  return (
    <ChartLaneMessage>
      <Box width="100%" height={`${LOADING_ANIMATION_HEIGHT_PX}px`}>
        <LoadingAnimation />
      </Box>
      <CustomTypography variant="bodySmall" fontWeight="bold">
        {LOADING_TEXT.TITLE}
      </CustomTypography>
      <CustomTypography variant="bodySmall" fontWeight="bold">
        {LOADING_TEXT.SUBTITLE}
      </CustomTypography>
    </ChartLaneMessage>
  );
}
